module.exports = __webpack_public_path__ + "static/sharma-7f12b50e44da9442a7056164a6c21505.png";